import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgOther2(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="9 9 41 43"
      fill="none"
      {...props}
    >
      <path
        fill={props.secondaryColor}
        d="M32.143 37.107c0-.73.592-1.321 1.322-1.321h13.214a1.321 1.321 0 1 1 0 2.643H33.464c-.73 0-1.32-.592-1.32-1.322m0 5.286c0-.73.592-1.322 1.322-1.322h13.214a1.321 1.321 0 1 1 0 2.643H33.464c-.73 0-1.32-.591-1.32-1.321m0 5.286c0-.73.592-1.322 1.322-1.322h13.214a1.321 1.321 0 0 1 0 2.643H33.464c-.73 0-1.32-.592-1.32-1.321"
      />
      <path
        fill={props.primaryColor}
        d="M25.756 33.477a1.982 1.982 0 1 1 2.202 3.296 1.982 1.982 0 0 1-2.202-3.296M28.179 19.929a1.322 1.322 0 0 0-2.643 0v9.25a1.321 1.321 0 1 0 2.643 0z"
      />
      <path
        fill={props.primaryColor}
        d="M26.857 14.643a13.227 13.227 0 0 1 13.147 11.896c.074.726.659 1.318 1.388 1.318.73 0 1.328-.593 1.267-1.32a15.858 15.858 0 1 0-17.122 17.122c.728.061 1.32-.536 1.32-1.266s-.593-1.315-1.32-1.388a13.215 13.215 0 0 1 1.32-26.362"
      />
    </svg>
  );
}
export default SvgOther2;
